<template>
    <v-row class="my-0 h-md-100" justify="center" justify-md="start">
        <v-col class="h-100" md="4" sm="8" cols="12">
            <div class="rounded pa-4 d-flex flex-column h-100" style="background-color: #f0f5fa">
                <h5 class="font-weight-bold text-primary mb-4">انتخاب فیلدهای سفارشی</h5>
                <v-text-field
                    class="mb-3 flex-grow-0"
                    hide-details
                    label="جستجو"
                    clearable
                    v-model="search"
                ></v-text-field>
                <p class="text-center font-weight-bold text-grey mt-10 text-meta" v-if="!customFieldList.length">موردی برای نمایش وجود ندارد.</p>
                <draggable class="px-2 flex-grow-1 overflow-y-auto" :sort="false" @start="drag = true" @end="drag = false" :group="{ name: 'customFields', pull: 'clone', put: false }" animation="200" tag="ul" :clone="({id}) => newItem(id)" item-key="id" :list="customFieldList">
                    <template #item="{element}">
                        <li style="list-style: none;">
                            <v-row @click="localValue.push(newItem(element.id))" align="center" class="mx-0 my-2 cursor-pointer bg-white rounded department-customFields-chooseCards">
                                <v-col cols="auto">
                                    <v-icon class="pa-4 rounded" color="primary" size="20" style="background-color: #cae2fe">{{ $system.customfieldTypes[element.type].icon }}</v-icon>
                                </v-col>
                                <v-col class="text-grey-darken-1 font-weight-bold text-small">{{ element.label }}</v-col>
                                <v-col class="department-customFields-chooseCards-icon ms-auto" cols="auto">
                                    <v-icon class="rounded pa-1" color="primary" size="24" style="background-color: #cae2fe4f">add</v-icon>
                                </v-col>
                            </v-row>
                        </li>
                    </template>
                </draggable>
            </div>
        </v-col>
        <v-col class="h-100" md="8" cols="12">
            <div class="d-flex flex-column h-100">
                <p class="mb-4 text-small text-grey-darken-1">فرم ها، مجموعه ای از فیلدهای سفارشی هستند که می توانند در بخش های مختلفی از سامانه به جمع آوری اطلاعات تکمیلی از کاربران کمک کنند. برای ایجاد فرم، ابتدا عنوان آنرا در کادر زیر نوشته و سپس فیلدهای مورد نظر خود از کادر سمت راست را کلیک نموده و یا آنها را سمت چپ بکشید.</p>
                <slot name="top"></slot>
                <div class="position-relative flex-grow-1 overflow-y-auto" :class="drag ? 'grey-lighten-4' : ''">
                    <p class="mt-3 font-weight-bold mb-0 text-grey text-meta position-absolute text-center" style="left: 0; right: 0;" v-if="!localValue.length">{{ drag ? 'اینجا رها کنید' : 'موردی برای نمایش وجود ندارد' }}</p>
                    <draggable group="customFields" @end="updateOrder()" handle=".handle" animation="200" tag="ul" v-model="localValue" item-key="id" class="h-100 px-2">
                        <template #item="{element, index}">
                            <li style="list-style: none;">
                                <v-row dense align="center" class="my-2 mx-0 rounded pa-2 bg-white department-customFields-draggableCards">
                                    <v-col cols="auto">
                                        <v-icon class="handle" color="secondary" size="24" style="cursor: move">drag_indicator</v-icon>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-icon color="primary" class="pa-4 rounded" style="background-color:#cae2fe">{{ $system.customfieldTypes[$system.customFields.find(x => x.id == element.id).type].icon }}</v-icon>
                                    </v-col>
                                    <v-col>
                                        <p class="mb-0 text-small text-grey-darken-1 font-weight-bold user-select-none">{{ $system.customFields.find(x => x.id == element.id).label }}</p>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-btn v-if="Object.hasOwn(element, 'public')" v-tooltip="`وضعیت فعلی: ${element.public ? 'قابل ویرایش توسط مشتری' : 'غیر قابل ویرایش توسط مشتری'}`" @click="() => {element.public = !element.public}" class="rounded" color="warning" variant="text" :icon="element.public ? 'icon-useredit' : 'icon-usereditno'"></v-btn>
                                        <v-btn v-if="Object.hasOwn(element, 'required')" v-tooltip="`وضعیت فعلی: ${element.required ? 'الزامی' : 'اختیاری'}`" @click="() => {element.required = !element.required}" :disabled="$system.customFields.find(x => x.id == element.id).type == 'checkbox'" class="rounded" color="warning" variant="text" :icon="element.required ? 'icon-starfill' : 'icon-star'"></v-btn>
                                        <v-btn v-if="Object.hasOwn(element, 'status')" v-tooltip="`وضعیت فعلی: ${ element.status ? 'در حال نمایش' : 'عدم نمایش' }`" @click="() => {element.status = !element.status}" class="rounded" color="secondary" variant="text" :icon="element.status ? 'visibility' : 'visibility_off'"></v-btn>
                                        <v-btn v-tooltip="'حذف'" @click="() => {localValue.splice(index, 1); updateOrder();}" class="rounded" color="error" variant="text" icon="icon-trash"></v-btn>
                                    </v-col>
                                </v-row>
                            </li>
                        </template>
                    </draggable>
                </div>
                <slot name="bottom"></slot>
            </div>
        </v-col>
    </v-row>
</template>
<script>
import draggable from 'vuedraggable';
export default {
    props: {
        modelValue: {
            type: Array,
            default: () => [],
        },
        required: {
            type: Boolean,
            default: true
        },
        status: {
            type: Boolean,
            default: true
        },
        public: {
            type: Boolean,
            default: false
        }
    },
    components: {
      draggable
    },
    data() {
        return {
            loading: false,
            drag: false,
            search: null,
        };
    },
    computed: {
        localValue: {
            get: function () {return this.modelValue; },
            set: function (value) { this.$emit('update:modelValue', value); }
        },
        customFieldList() {
            return this.$system.customFields.filter(x => !this.localValue.find(y => y.id == x.id) && (!this.search || x.label.includes(this.search)));
        }
    },
    methods: {
        newItem(id) {
            let res = {id, order: this.localValue.length};
            if (this.status)
                res['status'] = true;
            if (this.required)
                res['required'] = false;
            if (this.public)
                res['public'] = true;
            return res;
        },
        updateOrder() {
            for (let index = 0; index < this.localValue.length; index++) {
                this.localValue[index].order = index;
            }
        },
    },
};
</script>

<style lang="scss">
.department-customFields {
    &-draggableCards {
        box-shadow: 0 1px 5px transparent;
        outline: 1px solid rgba(128, 128, 128, 0.171);
        transition: all 0.3s;
        &:hover {
            box-shadow: 0 1px 10px #cae2fe;
            outline: 1px solid #cae2fe;
        }
    }
    &-chooseCards {
        box-shadow: 0 1px 5px transparent;
        &:hover {
            box-shadow: 0 1px 5px #cae2fe;
            outline: 1px solid #cae2fe;
        }
        &-icon {
            transition: all 0.3s;
            opacity: 0;
        }
        &:hover &-icon {
            opacity: 1;
        }
    }
}
</style>
